import script from "./UserAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./UserAvatar.vue?vue&type=style&index=0&id=6bfbc606&lang=css"

const __exports__ = script;

export default __exports__